export const ClientInfoReviewState = {
  Rejected: "Rejected",
  Pending: "Pending",
  Approved: "Approved",
};
